export function afterLast(input: string, target: string): string {
  const lastIndex = input.lastIndexOf(target)
  return lastIndex !== -1 ? input.substring(lastIndex + 1) : input
}

export const afterLastSlash = (input: string) => afterLast(input, '/')
